module.exports = __webpack_public_path__ + "static/githzerai_enlightened-cf30e90546f1492f121c8224f4a471c9.png";